import { Box, Typography, useTheme, styled } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { EidButton } from 'packages/eid-ui'
import { Icon } from 'packages/eid-icons'

const StyledIcon = styled(Icon)({
    '& g': {
        stroke: 'white',
    },
})

const EditCredential = ({ item }) => {
    const { t } = useTranslation()
    const handleEdit = () => {}
    const theme = useTheme()
    return (
        <>
            <Box width="120px">
                <EidButton.DrawerActionButton
                    fontColor="#ffffff"
                    bgColor={theme?.palette?.primary?.main}
                    width="100%"
                    onClick={handleEdit}
                >
                    <Box
                        display="flex"
                        alignItems="center"
                        height={'18px'}
                        width={'18px'}
                    >
                        <StyledIcon
                            name="EditFile"
                            fill={'white'}
                            stroke={'white'}
                        />
                    </Box>
                    <Box display="flex" alignItems="center" marginLeft="10px">
                        <Typography style={{ color: '#ffffff' }}>
                            {t('Edit')}{' '}
                        </Typography>
                    </Box>
                </EidButton.DrawerActionButton>
            </Box>
        </>
    )
}

export default EditCredential
